import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-import-branch-data',
  templateUrl: './import-branch-data.component.html',
  styleUrls: ['./import-branch-data.component.scss']
})
export class ImportBranchDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
